import name from './name'
import actions from './actions'

export default [
	name,
	actions,
]
